import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  EndUserRef,
  ExtensionMobilityRef,
  Global360View,
  PhoneRef,
} from '../../../../shared/models/generated/ziroModels';
import { UserDetailUiContext } from '../../../shared/contexts/user-detail-ui.context';
import { first, skip } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { PhoneUiContext } from '../../../../shared/phone-buttons/contexts/phone-ui.context';
import { Global360ViewContext } from '../../../../shared/contexts/global-360-view.context';
import { ZiroFormStateService } from '../../../../forms/ziro-form-state.service';
import { BottomNavClearButtonsList, BottomNavService } from '../../../../shared/bottom-nav/bottom-nav.service';
import { combineLatest, Subscription } from 'rxjs';
import { ZiroIcons } from '../../../../shared/models/ziro-icons.enum';
import { ToastService } from '../../../../shared/services/toast.service';
import { PhoneType } from '../../../../shared/models/service-type';
import { DeviceService } from '../../../../shared/phone-buttons/device.service';

@Component({
  selector: 'ziro-user-detail-phone',
  templateUrl: './user-detail-phone.component.html',
  providers: [PhoneUiContext, DeviceService],
  standalone: false,
})
export class UserDetailPhoneComponent implements OnInit, OnDestroy {
  private userDetailUiContext = inject(UserDetailUiContext);
  private global360ViewContext = inject(Global360ViewContext);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private ziroFormStateService = inject(ZiroFormStateService);
  private bottomNavService = inject(BottomNavService);
  private toastService = inject(ToastService);

  isLoading = true;
  endUserRef: EndUserRef;
  global360View: Global360View;
  isCopy: boolean;
  phoneType: PhoneType;
  PhoneType = PhoneType;

  private _subscription = new Subscription();

  ngOnInit(): void {
    this.isCopy = this.router.routerState.snapshot.url.includes('copy');
    this.phoneType = DeviceService.getPhoneTypeFromRoute(this.route.snapshot);
    const userDetailSubs = combineLatest([this.global360ViewContext.state$, this.userDetailUiContext.state$]).subscribe(
      ([global360View]) => {
        this.global360View = global360View;
        this.endUserRef = this.userDetailUiContext.getCurrentEnduser().ref;
        this.isLoading = false;
      },
    );
    this._subscription.add(userDetailSubs);
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  onSave(ref: PhoneRef | ExtensionMobilityRef): void {
    this.global360ViewContext.init(this.endUserRef.username);
    this.global360ViewContext.state$.pipe(skip(1), first()).subscribe(() => {
      this.toastService.pushSaveToast(this.phoneType, ref?.name, this._getZiroIconsFromPhoneType(this.phoneType));
      this.goHome();
    });
  }

  goHome(): void {
    if (!this.ziroFormStateService.getIsFormDirty()) {
      this.bottomNavService.dispatch(new BottomNavClearButtonsList());
    }
    const isNew = !this.route.snapshot.params.phoneId;
    this.router.navigate(this.isCopy ? ['../../../'] : isNew ? ['../'] : ['../..'], { relativeTo: this.route });
  }

  private _getZiroIconsFromPhoneType(phoneType: PhoneType): ZiroIcons {
    switch (phoneType) {
      case PhoneType.DESKPHONE: {
        return ZiroIcons.DESKPHONE_SMALL;
      }
      case PhoneType.EXTENSION_MOBILITY: {
        return ZiroIcons.EXTENSION_MOBILITY_SMALL;
      }
      case PhoneType.ANDROID: {
        return ZiroIcons.ANDROID_SMALL;
      }
      case PhoneType.IPHONE: {
        return ZiroIcons.IPHONE_SMALL;
      }
      case PhoneType.TABLET: {
        return ZiroIcons.TABLET_SMALL;
      }
      case PhoneType.IM_SOFTPHONE: {
        return ZiroIcons.SOFTPHONE_SMALL;
      }
      case PhoneType.CIPC: {
        return ZiroIcons.CIPC_SOLID;
      }
      default: {
        return ZiroIcons.DESKPHONE_SMALL;
      }
    }
  }
}
